export default [
	{
		path: '/joinAssistant',
		name: 'joinAssistant',
		component: () => import(/* joinAssistant*/ './index.vue'),
		meta: {
			title: '',
			// keepAlive: true  //是否设置为缓存数据页面
		},
		children: [
			{
				path: 'web/index',
				name: 'joinAssistant_web_index',
				component: () => import(/* joinAssistant_web_index*/ './pages/index.vue'),
				meta: {
					title: '',
					// keepAlive: true  //是否设置为缓存数据页面
				},
			},
			{
				path: 'web/step2',
				name: 'joinAssistant_web_step2',
				component: () => import(/* joinAssistant_web_step2*/ './pages/step2.vue'),
				meta: {
					title: '',
					// keepAlive: true  //是否设置为缓存数据页面
				}
			}
		]
	}
]
